import React, { useState, useEffect } from 'react';
import { callAPI } from "../../../utils/API";
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';

interface UserSelectProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  name?: string;
  label?: string;
  error?: boolean;
  helperText?: string;
}

const UserSelect: React.FC<UserSelectProps> = (props) => {
  const [options, setOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [shouldReload, setShouldReload] = useState<boolean>(true);

  useEffect(() => {
    if (!shouldReload) return;
    setShouldReload(false);
    callAPI("tables/users", "POST", {
      where: {
        enabled: 1
      },
    })
      .then((res) => {
        setOptions(res.map((user: any) => ({
          value: user.id,
          label: user.name,
        })));
        setLoading(false);
        if (!props.value && res.length > 0) {
          props.onChange(res[0].id);
        }
      })
      .catch((data) => {
        console.log(data);
      });
  }, [props, shouldReload]);

  return (
    <FormControl disabled={props.disabled} fullWidth error={props.error}>
      <InputLabel>{props.label}</InputLabel>
      <Select
        label={props.label}
        value={props.value}
        onChange={(e) => {
          props.onChange(parseInt(e.target.value as string));
        }}
        name={props.name}
      >
        {loading ? (
          <MenuItem disabled>Loading...</MenuItem>
        ) : (
          options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))
        )}
      </Select>
      {props.helperText ? <FormHelperText>{props.helperText}</FormHelperText> : null}
    </FormControl>
  );
}

export default UserSelect;